import { Flex, Text, Button } from '@chakra-ui/react';
import { localisable } from '../../generic/localisable';
import React from 'react';
import { ThankYouPropTypes } from './ThankYouPropTypes';
import { Link } from 'gatsby-link';
import { gotoHomeTextStyles } from './constant';
import { CallToActionButton } from '../../components';
import { getIndivCookie } from 'utils/auth';
import { emailFormButtonProps } from 'components/payRent/constants';

export const ThankYou = ({
  confirmationString,
  isMoveInEnabled,
  isReserveEnabled,
  paymentAmount,
  facilityName,
  logOffHandler
}: ThankYouPropTypes.ThankYouProps) => {
  const cToken = getIndivCookie('cToken');

  return (
    <Flex
      direction="column"
      bg="background.main"
      color="text.grey"
      padding={{ base: '16px 8px', sm: '16px' }}
      width={'100%'}
      gap={'24px'}
      textAlign={'center'}
      textStyle={'body1'}
      justifyContent='center'
    >
      <Text textStyle={'h2'}>{localisable.thankYou}</Text>
      <Flex direction="column" gap={'8px'}>
        {isReserveEnabled && (
          <>
            <Text>You've successfully reserved a unit at {facilityName}!</Text>
            <Text>
              Thank you for choosing {facilityName}!. {localisable.reserveText}
            </Text>
          </>
        )}
        {!!paymentAmount &&
          <Text>
            Your Payment of <Text as={'b'}>${paymentAmount?.toFixed(2)}</Text> was successful!
          </Text>
        }
        {!!confirmationString &&
          <Text>
            Your Confirmation Number is <Text as={'b'}>{confirmationString}</Text>
          </Text>
        }
        {isMoveInEnabled && <Text>{localisable.agreementText}</Text>}
      </Flex>
      {cToken && <Button
        {...emailFormButtonProps}
        onClick={() => logOffHandler()}
        bg='brand.lightTertiary'
        minW={{ base: '100%', sm: '204px' }}
      >
        <Text textStyle='buttonSmall' color='brand.secondary' >{localisable.logOff}</Text>
      </Button>}
      <Text {...gotoHomeTextStyles}>
        <Link to="/">{localisable.goToHome}</Link>
      </Text>
    </Flex>
  );
};
